exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"variable.scss","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--9-1!./node_modules/sass-loader/dist/cjs.js??ref--9-2!./src/assets/styles/variable.scss
// module id = 4xZj
// module chunks = 38